import { trpc } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { reportQueryOptions, reportSearchDeps } from '@/hooks/use-report'
import { noop } from '@tanstack/react-query'

/**
 * Data-owning layout for a selected employee (`/employees/$employeeId/*`): the employeeId-keyed detail its subtree
 * and the chrome above it read, plus the REPORT query, as in the other four sections — on the leaf that key would
 * re-key the match on every ámbito/source switch and paint its skeleton over the report being read. NO component:
 * nothing to code-split, so no chunk to await and nothing painted on a re-key. The chrome ABOVE this match (the
 * nav-stack screen title, the breadcrumb) reads it with `useMatch({ from: '/_app/employees/_list/$employeeId' })`.
 */
export const Route = createFileRoute('/_app/employees/_list/$employeeId')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  context: ({ deps, params }) => ({
    reportQueryOptions: reportQueryOptions(deps, params),
    employeeQueryOptions: trpc.employees.getEmployee.queryOptions(Number(params.employeeId)),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.employeeQueryOptions).catch(noop)
    if (context.reportQueryOptions) context.queryClient.query(context.reportQueryOptions).catch(noop)
  },
  // No pendingComponent: its ABSENCE is what makes this layout's own re-key harmless — the router presents nothing
  // for a match without one, so the pane stays until the leaf's data lands. The report leaf owns the skeleton.
})
